import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";

const NAV = [
  { to: "/breaks", label: "Breaks" },
  { to: "/experiences", label: "Experiences" },
  { to: "/heart-of-england", label: "Heart of England" },
  { to: "/how-it-works", label: "How it works" },
  { to: "/faqs", label: "FAQs" },
];

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 border-b border-black/5 bg-sand/80 backdrop-blur-xl" data-testid="site-header">
      <div className="container-tpb flex h-16 items-center justify-between gap-6">
        <Link to="/" className="flex items-baseline gap-2" data-testid="header-logo" aria-label="The Perfect Break home">
          <span className="font-serif text-2xl font-semibold tracking-tight text-primary">The Perfect Break</span>
          <span className="hidden text-[10px] font-semibold uppercase tracking-[0.25em] text-ink-muted sm:inline">UK breaks for adults</span>
        </Link>
        <nav className="hidden items-center gap-7 lg:flex" aria-label="Main navigation">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-300 ${isActive ? "text-primary" : "text-ink hover:text-primary"}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/breaks" className="btn-primary hidden !px-5 !py-2.5 lg:inline-flex" data-testid="header-find-break-button">
            Find your break <ArrowRight className="h-4 w-4" />
          </Link>
          <button
            className="rounded-full p-2 text-ink transition-colors duration-300 hover:bg-sand-dark lg:hidden"
            onClick={() => setOpen(!open)}
            aria-expanded={open}
            aria-label="Toggle menu"
            data-testid="mobile-menu-button"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="border-t border-sandline bg-sand px-5 py-6 lg:hidden" aria-label="Mobile navigation" key={location.pathname}>
          <div className="flex flex-col gap-4" onClick={() => setOpen(false)}>
            {NAV.map((item) => (
              <Link key={item.to} to={item.to} className="text-base font-medium text-ink" data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {item.label}
              </Link>
            ))}
            <Link to="/breaks" className="btn-primary mt-2" data-testid="mobile-find-break-button">
              Find your break <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}
